import PropTypes from 'prop-types';
import { Component } from 'react';
import { player } from 'src/client/player';
import { storeSingleton } from 'src/client/store/storeSingleton';
import { selectIsNowPlayingDialogOpen } from 'src/common/selectors/dialog';
import { mintSingleton } from '../../../client/mint';
import isServer from '../../utils/isServer';

export default function withAdScreenRequest(getScreenName) {
  return (BaseComponent) => {
    class WithScreenAdRequest extends Component {
      static propTypes = {
        match: PropTypes.object.isRequired,
      };

      constructor(props) {
        super(props);
        if (!isServer()) {
          this.updateCurrentScreen();
        }
      }

      async updateCurrentScreen() {
        const isNowPlayingDialogOpen = selectIsNowPlayingDialogOpen(storeSingleton.state);
        const screenName = isNowPlayingDialogOpen ? 'nowPlaying' : getScreenName(this.props);

        // updating currentScreen for displayAds
        mintSingleton.updateState('currentScreen', screenName);
        player.setAppSessionData({ currentScreen: screenName });
      }

      componentDidUpdate(prevProps) {
        if (prevProps.match.params !== this.props.match.params) {
          this.updateCurrentScreen();
        }
      }

      render() {
        return <BaseComponent {...this.props} />;
      }
    }

    return WithScreenAdRequest;
  };
}
